/* TLC dispatch ticker (Option I). Reads the existing dispatch, shipping and returns lines
   on the product page and shows them as one slow-moving line. The wording still comes from
   the original block, so edit it there. "Order before 2pm AEST" becomes a live countdown
   on weekdays before the cut-off (Brisbane time); otherwise the original wording shows.
   On the main product page the moving line hangs under the sticky header so it stays in
   view as you scroll (space for it is kept by tlc-dispatch.css); the * note stays by the
   buy buttons. If a product page has no dispatch lines, the kept space is released. */
(function () {
  function bneNow() { var n = new Date(); return new Date(n.getTime() + (n.getTimezoneOffset() + 600) * 60000); }
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function build(box) {
    if (box.getAttribute('data-tlcdt')) return;
    var lines = box.querySelectorAll('.tlc-pdp-extra');
    if (!lines.length) return;
    box.setAttribute('data-tlcdt', '1');

    var items = [], dispatch = null;
    [].forEach.call(lines, function (l) {
      var t = (l.textContent || '').replace(/\s+/g, ' ').trim();
      if (l.classList.contains('tlc-pdp-extra--dispatch')) { dispatch = t; items.push({ d: true, t: t }); return; }
      t.split(/\s*·\s*/).forEach(function (p) { if (p) items.push({ t: cap(p) }); });
    });
    var note = box.querySelector('.tlc-pdp-extras__note');

    /* Cut-off hour from the wording, e.g. "before 2pm AEST" */
    var cut = null, m = dispatch && dispatch.match(/before\s+(\d{1,2})(?::(\d{2}))?\s*(am|pm)\s*AEST/i);
    if (m) { var h = +m[1] % 12 + (/pm/i.test(m[3]) ? 12 : 0); cut = h * 60 + (+m[2] || 0); }

    var wrap = document.createElement('div');
    wrap.className = 'tlcdt';
    var vh = document.createElement('ul');
    vh.className = 'visually-hidden';
    items.forEach(function (it) { var li = document.createElement('li'); li.textContent = it.t; vh.appendChild(li); });
    var vp = document.createElement('div');
    vp.className = 'tlcdt__vp';
    vp.setAttribute('aria-hidden', 'true');
    var track = document.createElement('div');
    track.className = 'tlcdt__track';
    vp.appendChild(track);
    wrap.appendChild(vh);
    wrap.appendChild(vp);

    function group() {
      var g = document.createElement('div');
      g.className = 'tlcdt__group';
      items.forEach(function (it) {
        var s = document.createElement('span');
        s.className = 'tlcdt__item' + (it.d ? ' tlcdt__item--d' : '');
        s.textContent = it.t;
        g.appendChild(s);
        var dot = document.createElement('span'); dot.className = 'tlcdt__sep'; dot.textContent = '·'; g.appendChild(dot);
      });
      return g;
    }

    function countdown() {
      if (cut === null) return;
      var b = bneNow(), day = b.getDay(), mins = b.getHours() * 60 + b.getMinutes();
      var left = cut - mins, live = day > 0 && day < 6 && left > 0;
      var txt = live ? 'Order in ' + (Math.floor(left / 60) ? Math.floor(left / 60) + 'h ' : '') + (left % 60) + 'm for same-day dispatch' + (/\*/.test(dispatch) ? '*' : '') : dispatch;
      track.querySelectorAll('.tlcdt__item--d').forEach(function (e) {
        if (e.textContent !== txt) { e.textContent = txt; e.classList.toggle('is-live', live); }
      });
    }

    track.appendChild(group());
    track.appendChild(group());
    if (note) { var n = document.createElement('p'); n.className = 'tlcdt__note'; n.textContent = note.textContent.trim(); wrap.appendChild(n); }
    box.classList.add('tlcdt-on');
    box.insertBefore(wrap, box.firstChild);

    /* Main product page: hang the moving line under the sticky header */
    var hdr = document.querySelector('.section-header');
    if (hdr && box.closest('[id*="__main"]') && !document.querySelector('.tlcdt-bar')) {
      var bar = document.createElement('div');
      bar.className = 'tlcdt-bar';
      bar.appendChild(vp);
      hdr.appendChild(bar);
      document.documentElement.classList.add('tlcdt-top');
    }

    countdown();
    setInterval(countdown, 30000);

    function speed() { var w = track.firstChild.getBoundingClientRect().width; if (w) track.style.animationDuration = Math.max(14, w / 32) + 's'; }
    speed();
    window.addEventListener('resize', speed);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(speed);

    /* Hold still while she's touching it */
    vp.addEventListener('touchstart', function () { track.classList.add('is-paused'); }, { passive: true });
    vp.addEventListener('touchend', function () { track.classList.remove('is-paused'); }, { passive: true });
  }

  function run() {
    document.querySelectorAll('.product-form .tlc-pdp-extras').forEach(build);
    if (!document.querySelector('.tlcdt-bar')) document.documentElement.classList.add('tlcdt-none');
    else document.documentElement.classList.remove('tlcdt-none');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
